import { Component, input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-info-banner',
  templateUrl: 'info-banner.component.html',
  styleUrls: ['./info-banner.component.scss', './_info-banner-theme.component.scss']
})
export class InfoBannerComponent {
  color = input<UiPalette>('primary');
  icon = input<IconDefinition>();
  iconAlign = input<'center' | 'top'>('center');
}
